var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.needTrim)?_c('span',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.trimmedText))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.fullText))])])],1):_c('span',[_c('span',[_vm._v(_vm._s(_vm.fullText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-473682db","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/TextTooltipTrimmer.vue
// module id = null
// module chunks = 